module.exports = __webpack_public_path__ + "static/media/toilet.e9c36717.svg";